<template>
  <b-container>
    <img
      id="logo"
      src="../assets/svg/TSNY_Logo_Full.svg"
      alt=""
      @click="toLogin"
    />
  </b-container>
</template>

<script>
export default {
  name: "LogoFull",
  methods: {
    toLogin: function() {
      this.$router.replace({
        name: "Login"
      });
    }
  }
};
</script>

<style scoped>
#logo {
  width: 400px;
  height: auto;
  margin-top: 100px;
  margin-bottom: 100px;
}

#logo:hover {
  cursor: pointer;
}
</style>
